// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/services/notification-service';
import { TranslateService } from '@ngx-translate/core';
import { LicenseType, selectableTypes } from '../../../types/subscription';
import { MatSelectChange } from '@angular/material/select';


export const isCountValid = (total: number, allocated: number, used: number, maxCount: number) =>
  total >= allocated && total >= used && total <= maxCount;


@Component({
    selector: 'app-edit-license-count',
    templateUrl: './edit-license-count.component.html',
    styleUrls: ['./edit-license-count.component.scss'],
    standalone: false
})
export class EditLicenseCountComponent {
  fHeader: string;
  fCancel: string;
  fSave: string;
  fCount: string;
  notifyAdminsByEmail: boolean;
  selectedLanguage: string;
  maxCount: number;

  subTypes = selectableTypes;
  subType = selectableTypes[selectableTypes.length - 1];

  constructor(
    public dialogRef: MatDialogRef<EditLicenseCountComponent>,
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {
    this.translate.get(['EL_HEADER', 'CANCEL_CAP', 'SAVE_CAP', 'COUNT']).subscribe(vals => {
      this.fHeader = vals['EL_HEADER'];
      this.fCancel = vals['CANCEL_CAP'];
      this.fSave = vals['SAVE_CAP'];
      this.fCount = vals['COUNT'];
    });
    this.notifyAdminsByEmail = false;
    this.selectedLanguage = localStorage.getItem('language') || 'en';
    this.maxCount = data.maxCount;
    this.subType = this.toType(data.subType);
  }

  toType(subType: number) {
    let type = selectableTypes.find(t => t.value === LicenseType.LICENSE_TYPE_TIME_LIMITED);

    const type_from_data = selectableTypes.find( stype => subType === stype.value );
    if ( type_from_data ) {
      type = type_from_data;
    }
    return type;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSubmit() {
    if (isCountValid(+this.data.total, +this.data.allocated, +this.data.used, +this.maxCount)) {
      const result = {
        newCount: +this.data.total - this.data.allocated,
        notify: this.notifyAdminsByEmail,
        notifyLanguage: this.selectedLanguage,
        selectedSubType: this.subType.value,
        enablePBAExtendedFeatures: this.data.enablePBAExtendedFeatures,
        enablePBALogErase: this.data.enablePBALogErase
      };
      this.dialogRef.close(result);
    } else {
      this.data.total = +this.maxCount;
      const language = localStorage.getItem('language') ?? 'en-US';
      this.notificationService.showWarning(this.translate.instant('ERROR_RANGE', {
        start: this.data.allocated > this.data.used ? this.data.allocated : this.data.used,
        end: new Intl.NumberFormat(language).format(+this.maxCount)
      }));
    }
  }

  clickedPlus() {
    if (+this.data.total + 1 < this.data.allocated) {
      this.data.total = this.data.allocated;
    } else if (+this.data.total + 1 <= this.maxCount) {
      this.data.total = +this.data.total + 1;
    } else if (+this.data.total + 1 > this.maxCount) {
        this.data.total = this.maxCount;
    }
  }

  clickedMinus() {
    if (+this.data.total - 1 > this.maxCount) {
      this.data.total = this.maxCount;
    } else if (+this.data.total - 1 >= this.data.allocated) {
        this.data.total = +this.data.total - 1;
    } else if (+this.data.total - 1 < this.data.allocated) {
        this.data.total = this.data.allocated;
    }
  }

  keyDown(event) {
    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowLeft':
      case 'ArrowUp':
      case 'ArrowDown':
      case 'Delete':
      case 'Tab':
      case 'Backspace':
        return;
    }
    if (!event?.key?.match(/[0-9]/)) {
      event.preventDefault();
    }
  }

  onLanguageChanged(language) {
    this.selectedLanguage = language;
  }

  onNotifyCheckChanged(event) {
    this.notifyAdminsByEmail = (event && event.checked) || false;
  }

  typeChanged(event: MatSelectChange) {
    this.subType = event.value;
  }
}
